import React from 'react'

import BackDrop from './../../../resources/HomePageResources/dubai.svg'
import PlatformLeft from  './../../../resources/HomePageResources/platform-down-left.svg'
import PlatformRight from  './../../../resources/HomePageResources/platform-down-right.svg'
import '../../../styles/HomePageStyles/PlatformStyles/dubai.css'

import DubaiHotel from './../../../resources/HomePageResources/dubai-hotel.svg'
import DubaiBench from './../../../resources/HomePageResources/sydney-bench.svg'

import DubaiPipe from './../../../resources/HomePageResources/pipes/dubai-pipe.svg'

export default class TokyoPlatform extends React.Component{
    render(){
        return(
            <div className="plat__container" style={{width: '320px'}}>
                <div className="plat__backdrop">
                    <img className="plat__backdrop-img" src={BackDrop} />
                    <div className="plat__content-box dubai__content-box">
                        <div className="dubai__top">

                        </div>
                        <div className="dubai__bottom">
                            <div className="dubai__bench">
                                <img className="dubai__bench-img" src={DubaiBench} />
                            </div>
                            <div className="dubai__hotel">
                                <img className="dubai__hotel-img" src={DubaiHotel} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="plat__platform">
                    <img className="plat__platform-left" src={PlatformLeft} />
                    <div className="plat__platform-middle" />
                    <img className="plat__platform-right" src={PlatformRight} />
                </div>
                <div className="dubai__pipe">
                    <img src={DubaiPipe} />
                    <div className="dubai__pipe-c-1" />
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Platforms/DubaiPlatform.js